import Glide from '@glidejs/glide';
import css from '../../node_modules/@glidejs/glide/src/assets/sass/glide.core.scss';
const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

document.addEventListener('DOMContentLoaded',function() {

    const facts = document.getElementById('factsCarousel'),
          timeline = document.getElementById('timelineCarousel');

    const factsCarousel = function() {

        const glide = new Glide(facts, {
            animationDuration: 600,
            type: 'slider',
            autoplay: false,
            gap: 0,
            perView: 1,
            rewind: true
        });

        setTimeout(function() {
            glide.mount();
        }, 1)
    };

    window.offerslideCarousel = function() {

        const offerslide = document.getElementById('offerslideCarousel');

        const glide = new Glide(offerslide, {
            animationDuration: 600,
            type: 'slider',
            autoplay: false,
            gap: 0,
            perView: 1,
            rewind: false
        });

        const nav = function() {

            const el = document.getElementById('offerslideNav'),
                  items = el.getElementsByClassName('js-item');

            const action = function(e) {
                let target = cutme.Helpers.thisindex(e.currentTarget);

                for (let i = 0; i < items.length; i ++) {
                    items[i].classList.remove('is-active');
                }

                e.currentTarget.classList.add('is-active');

                glide.go('=' + target);

                e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
            };

            for (let i = 0; i < items.length; i ++) {
                items[i].addEventListener('click', action);
            }
        };

        const autoHeight = function() {
            const activeSlide = document.querySelector('.c-offerslide .glide__slide--active .o-wrap');
            const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;

            const glideTrack = document.querySelector('.c-offerslide .glide__track');
            const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;

            if (activeSlideHeight !== glideTrackHeight) {
                glideTrack.style.height = `${activeSlideHeight+60}px`;
            }
        };

        glide.on('build.after', autoHeight);
        glide.on('run.after', autoHeight);

        setTimeout(function() {
            glide.mount();

            nav();
        }, 1)
    };

    window.storyCarousel = function() {

        let index = 0;
        const closeBtn = document.getElementsByClassName('js-closeStories')[0];
        const openBtn = document.getElementsByClassName('js-openStories')[0];

        const story = document.getElementById('storyCarousel');
        const storyEl = document.getElementById('story');

        const glide = new Glide(story, {
            animationDuration: 600,
            type: 'carousel',
            autoplay: false,
            gap: 0,
            perView: 1,
//            dragThreshold: false,
//            touchRatio: 0
        })


        const closeStory = function() {
            storyEl.classList.remove('is-visible');
            enableBodyScroll(storyEl);
        }

        const autoHeight = function() {
            const activeSlide = document.querySelector('.c-story .glide__slide--active .o-wrap');
            const glideTrack = document.querySelector('.c-story .glide__track');
            if (activeSlide.offsetWidth < 800) {
                const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;
                const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;

                if (activeSlideHeight !== glideTrackHeight) {
                    glideTrack.style.height = `${activeSlideHeight + 60}px`;
                }
            } else {
                glideTrack.style.height = `100%`;
            }
        };

        glide.on('build.after', autoHeight);

        glide.on('run.before', function() {
            index = glide.index;
            navbarchange();
        })
        
        glide.on('run.after', function() {
            index = glide.index;
            autoHeight();
        })
        
        const navbarchange = () => {
            const el = document.getElementById('storyNavCarousel'),
                  name = el.getElementsByClassName('js-name')[0],
                  next = el.getElementsByClassName('js-next')[0],
                  names = story.getAttribute('data-name'),
                  nexts = story.getAttribute('data-next'),
                  nextArr = nexts.split(","),
                  namesArr = names.split(",");
                  
            next.innerHTML = nextArr[index];
            name.innerHTML = namesArr[index];
        }

        const nav = function() {
            const action = function(e) {
                navbarchange();
                glide.go('>');

                e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
            };

            document.getElementById('storyNavCarousel').addEventListener('click', action);
        };

        setTimeout(function() {
            glide.mount();

            nav();
        }, 1)

        openBtn.addEventListener('click', function(e) {

            storyEl.classList.add('is-visible');
            disableBodyScroll(storyEl);

            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        });

        closeBtn.addEventListener('click', closeStory);

        // Hide menu on ESC

        document.addEventListener('keydown', function(evt) {
            // evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key == "Escape" || evt.key == "Esc");
            } else {
                isEscape = (evt.keyCode == 27);
            }
            if (isEscape) {
                closeStory();
            }
        });
    };

    const timelineCarousel = function() {
        const captions = document.getElementById('captions'),
              caption = captions.getElementsByTagName('li');

        const startAt = caption.length > 1 ? caption.length - 2: 0;

        const glide = new Glide(timeline, {
            animationDuration: 600,
            autoplay: false,
            gap: 0,
            perView: 4,
            startAt,
            focusAt: 'center',
            rewind: false,
            breakpoints: {
                775: {
                    perView: 1
                }
            }
        });

        setTimeout(function() {
            glide.mount();
        }, 1)

        glide.on('run.before', function(event) {
            for (let i = 0; i < caption.length; i++) {
                caption[i].classList.remove('is-active');
            }
        });

        glide.on('move.after', function(event) {
            let index = glide.index;

            let position = index;
				position = position * 100,

            captions.style.transform  = "translate3d(-"+position+"%, 0, 0)";
            caption[index].classList.add('is-active');
        });
    };

    facts ? factsCarousel() : false;
    timeline ? timelineCarousel() : false;


}, false);
